import BaseApi, { FetchMethodType } from 'api/BaseApi';
import { stringifyRequestBody } from 'utils/fetch';

export interface IQuilttSession {
  token: string;
  connectionId?: string;
}

export interface IGetStatusResponse {
  isConnected: boolean;
}

export interface ICreateSessionParams {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
}

export interface IUpdateQuilttConnectionParams {
  id: string;
  connectionId: string;
}

export interface IQuilttConnection {
  id: string;
  connectionId?: string;
}

export interface IQuilttApi {
  createSession(params: ICreateSessionParams): Promise<IQuilttSession>;
  updateConnection(params: IUpdateQuilttConnectionParams): Promise<IQuilttConnection>;
  getConnection(): Promise<IQuilttConnection>;
  getStatus(): Promise<IGetStatusResponse>;
}

export default class QuilttRestApi extends BaseApi implements IQuilttApi {
  public async createSession(params: ICreateSessionParams): Promise<IQuilttSession> {
    return this.fetch<IQuilttSession>('/quiltt/sessions', {
      method: FetchMethodType.POST,
      body: stringifyRequestBody(params),
    });
  }

  public async updateConnection(params: IUpdateQuilttConnectionParams) {
    return this.fetch<IQuilttConnection>(`/quiltt/connections/${params.id}`, {
      method: FetchMethodType.PUT,
      body: stringifyRequestBody({
        connectionId: params.connectionId,
      }),
    });
  }

  public async getConnection() {
    return this.fetch<IQuilttConnection>('/quiltt/connections', {
      method: FetchMethodType.GET,
    });
  }

  public async getStatus(): Promise<IGetStatusResponse> {
    return this.fetch<IGetStatusResponse>('/quiltt/status');
  }
}
